import * as React from "react";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import HomeIcon from "@mui/icons-material/Home";

import MyTabbedLayout from "../mui/TabbedLayout";
import Inbox from "./Inbox";
import BulkNew from "./BulkNew";

export const TITLE_HOME = "Messenger";
export const TITLE_INBOX = TITLE_HOME + " > Inbox";
export const TITLE_BULK = TITLE_HOME + " > Bulk";

export default function Kitchen() {

  const [state, setState] = React.useState(TITLE_INBOX);

  const onBackClickListener = () => {
    if (state !== TITLE_INBOX) {
      if (state === TITLE_BULK) {
        setState(TITLE_INBOX);
      }
    }
  };


  return (
    <div>
    
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginBlockEnd: "16px",
        }}
      >
        <div
          style={{
            padding: 8,
            background: "red",
            display: "inline-flex",
            flexDirection: "row",
            borderRadius: "10px",
            boxShadow: "1px 1px 5px 2px rgb(0,0,0,0.2)",
          }}
        >
          <HomeIcon
            onClick={() => {
              if (state !== TITLE_BULK && state !== TITLE_INBOX)
                setState(TITLE_INBOX);
            }}
            sx={{
              color: "white",
              alignSelf: "center",
              marginInlineEnd: 1,
            }}
          />
          {state !== TITLE_INBOX && state !== TITLE_BULK ? (
            <ArrowBackIosIcon
              onClick={onBackClickListener}
              sx={{
                color: "white",
                alignSelf: "center",
                marginInlineEnd: 1,
                marginInlineStart: 1,
              }}
            />
          ) : (
            ""
          )}
          <h1
            style={{
              color: "rgb(255, 255, 255)",
              fontSize: 20,
            }}
          >
            {state}
          </h1>
        </div>
      </div>
      <div>
        {state === TITLE_INBOX || state === TITLE_BULK ? (
          <MyTabbedLayout
            defaultSelection={state === TITLE_INBOX ? 0 : 1}
            onSelection={(value) => {
              if (value === 0) setState(TITLE_INBOX);
              else setState(TITLE_BULK);
            }}
            tabs={[
              {
                title: "Reports",
                element: (
                  <Inbox
                
                  />
                ),
              },
              {
                title: "Bulk",
                element: <BulkNew/>,
              },
            ]}
          />
        ) : null}
      </div>
    </div>
  );
}
